import CryptoJs from 'crypto-js';

/**
 * url md5加密
 * @param url
 * @returns
 */
export const getCryptoPwd = (url: string) => {
  const md5 = CryptoJs.MD5(url).toString();
  let localPath = md5;
  if (url.includes('.')) {
    const suffix = url.substring(url.lastIndexOf('.'));
    localPath = md5 + suffix;
  }
  return localPath;
};
